module.exports = __webpack_public_path__ + "static/media/9.d475ec50.jpg";